/* Wspolna logika listy propozycji w koszyku: wybor wariantu chipami
   i dodanie do koszyka kanalem motywu (cart/add.js + theme:cartchanged).
   Uzywane przez drawer i strone /cart. */
(function () {
  if (window.__slcrBound) return;
  window.__slcrBound = true;

  function money(el, price, was) {
    var box = el.closest('.slcr__row');
    if (!box) return;
    var target = box.querySelector('[data-slcr-price]');
    if (!target) return;
    if (was) {
      target.innerHTML = '<s class="slcr__was"></s> <span class="slcr__now"></span>';
      target.querySelector('.slcr__was').textContent = was;
      target.querySelector('.slcr__now').textContent = price;
    } else {
      target.innerHTML = '<span class="slcr__amount"></span>';
      target.querySelector('.slcr__amount').textContent = price;
    }
  }

  document.addEventListener('click', function (e) {
    // wybor wariantu
    var opt = e.target.closest('.slcr__opt');
    if (opt) {
      var row = opt.closest('.slcr__row');
      if (!row) return;
      row.querySelectorAll('.slcr__opt').forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-active');
      opt.setAttribute('aria-pressed', 'true');
      var add = row.querySelector('[data-slcr-add]');
      if (add) add.setAttribute('data-slcr-id', opt.getAttribute('data-slcr-variant'));
      money(opt, opt.getAttribute('data-slcr-price'), opt.getAttribute('data-slcr-was'));

      // packshot i adres wariantu
      var src = opt.getAttribute('data-slcr-img');
      if (src) {
        var img = row.querySelector('.slcr__thumb img');
        if (img && img.getAttribute('src') !== src) {
          img.setAttribute('src', src);
          img.removeAttribute('srcset');
        }
      }
      var url = opt.getAttribute('data-slcr-url');
      if (url) {
        var thumb = row.querySelector('[data-slcr-thumb]');
        var name = row.querySelector('.slcr__name');
        if (thumb) thumb.setAttribute('href', url);
        if (name) name.setAttribute('href', url);
      }
      return;
    }

    // dodanie do koszyka — tym samym kanalem, ktorego uzywa motyw
    var btn = e.target.closest('[data-slcr-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-slcr-id');
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Dodaję…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw r;
        btn.textContent = 'Dodano';
        btn.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
/* „Kontynuuj zakupy" — zamyka drawer kanalem motywu, z awaryjnym kliknieciem
   w przycisk zamykania, gdyby zdarzenie nie mialo sluchacza. */
(function () {
  if (window.__slkContinueBound) return;
  window.__slkContinueBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-slk-continue]');
    if (!btn) return;
    e.preventDefault();
    try {
      document.documentElement.dispatchEvent(new CustomEvent('theme:close-cart-drawer', { bubbles: true, cancelable: false }));
    } catch (err) {}
    var close = document.querySelector('.cart-drawer-modal .cc-popup-close');
    if (close) close.click();
  });
})();